// extracted by mini-css-extract-plugin
export default {"form":"MealForm_form__3A+7i"};